import React, { useEffect } from 'react'
import Proptypes from 'prop-types'
import { SSRProvider } from 'react-bootstrap'

import Header from '~components/Layout/components/Header'
import SectionCta from '~components/SectionCta'
import Footer from '~components/Layout/components/Footer'
import SVGDefs from '~components/Layout/components/SVGDefs'

import * as s from './SecondaryLayout.module.scss'

const SecondaryLayout = ({ children, heroChildren, slug }) => {
  useEffect(() => {
    const body = document.querySelector('body')
    body.style.overflow = 'auto'
  }, [])

  return (
    <SSRProvider>
      <section className={s.layout}>
        <Header slug={slug} className={s.layout_hero_secondary} />
        <div className={s.layout_hero}>{heroChildren}</div>
        <main className="main">{children}</main>
        <SectionCta />
        <Footer />
        <SVGDefs />
      </section>
    </SSRProvider>
  )
}

export default SecondaryLayout

SecondaryLayout.propTypes = {
  slug: Proptypes.string,
  children: Proptypes.node.isRequired,
  heroChildren: Proptypes.node.isRequired,
}

SecondaryLayout.defaultProps = {
  slug: '',
}
